import React from 'react';
import type { StationeryTemplateCategoryEnum } from '@graphql/generated-base';
import { createContext } from '@shared/utils/createContext';

export const [CardCategoryContextProvider, useCardCategoryContext] = createContext<{
  currentCategory: StationeryTemplateCategoryEnum;
}>({ name: 'CardCategory' });

type Props = Readonly<{
  category: StationeryTemplateCategoryEnum;
}>;

export const CardCategoryProvider: React.FC<Props> = ({ children, category }) => (
  <CardCategoryContextProvider value={{ currentCategory: category }}>{children}</CardCategoryContextProvider>
);
